
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TrainingCourse } from 'app/_models/training/training-course.model';
import { TrainingSectionType } from 'app/_models/training/training-section-type';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';
import Swal from 'sweetalert2';
import { Globals } from './../../../_globals';

@Component({
  selector: 'training-page',
  templateUrl: './training-page.component.html',
})
export class TrainingPageComponent implements OnInit {
  public trainingId: number;
  public routeRole: any;
  public course: TrainingCourse;
  public TrainingSectionType = TrainingSectionType; // allow enum in template

  constructor(
    private trainingService: TrainingService,
    private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private globals: Globals,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.trainingId = parseInt(params.trainingId);
    });
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.setupPage();
  }

  private setupPage() {
    this.trainingService.getTrainingCourseById(this.trainingId).subscribe((course) => {
      this.course = course;
    },(error) => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not load training data');
    });
  }

  public deleteInductionTraining() {
    if (this.course.sites.length > 0) {
      this.notificationService.notify('danger', 'Error', 'You can\'t delete a course that is currently used on a site');
      return;
    }

    Swal.fire({
      title: 'Delete Training Course?',
      text: 'You will not be able to revert this',
      type: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'confirm-danger',
      },
      confirmButtonText: 'Yes, delete it',
    }).then((result) => {
      if (result.value) {
        this.trainingService.deleteInductionTraining(this.trainingId).subscribe(
          (response) => {
            this.notificationService.notify('success', 'Success', 'Deleted induction/training section');
            this.router.navigate([`/${this.routeRole}/training`]);
          },
          (error) => {
            console.error(error);
            this.notificationService.notify('danger', 'Error', 'Could not delete induction/training section');
          }
        );
      }
    });
  }

  public openFile(src) {
    this.trainingService.openFile(src);
  }

  public openVideo(src) {
    window.open(src);
  }
}
